import * as React from "react"

const PauseIcon = (props: any) => (
    <svg width={33} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16.5 2.667C9.14 2.667 3.166 8.64 3.166 16S9.14 29.333 16.5 29.333c7.36 0 13.333-5.973 13.333-13.333S23.86 2.666 16.5 2.666Zm-2.667 18.666c-.733 0-1.333-.6-1.333-1.333v-8c0-.733.6-1.334 1.333-1.334s1.333.6 1.333 1.334v8c0 .733-.6 1.333-1.333 1.333Zm5.333 0c-.733 0-1.333-.6-1.333-1.333v-8c0-.733.6-1.334 1.334-1.334.733 0 1.333.6 1.333 1.334v8c0 .733-.6 1.333-1.334 1.333Z"
            fill="#2BB792"
        />
    </svg>
)

export default PauseIcon
